(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["powerboss-landing"] && !Shopify.designMode) return;
  try {
    


(() => {
 const init = (root) => {

  if(!root || root.dataset.pbInitialized) return;
  root.dataset.pbInitialized='true';
  const nav=root.querySelector('.pb-nav');
  const hero=root.querySelector('.pb-hero');
  const controller=new AbortController();
  let pending=false;
  const update=() => {
    pending=false;
    const offset=parseFloat(getComputedStyle(nav).top)||0;
    const height=nav.getBoundingClientRect().height;
    const visible=hero.getBoundingClientRect().bottom<=offset && root.getBoundingClientRect().bottom>offset+height;
    nav.dataset.visible=String(visible);
    nav.inert=!visible;
    nav.setAttribute('aria-hidden',String(!visible));
    root.style.setProperty('--pb-nav-height',height+'px');
  };
  const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
  window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
  window.addEventListener('resize',schedule,{passive:true,signal:controller.signal});
  window.addEventListener('pageshow',schedule,{signal:controller.signal});
  const observer=new ResizeObserver(schedule);
  observer.observe(hero);
  document.addEventListener('shopify:section:unload',event=>{
    if(event.target.contains(root)){controller.abort();observer.disconnect();delete root.dataset.pbInitialized;}
  },{signal:controller.signal});
  const reviewTrack=root.querySelector('.pb-review-track');
  if(reviewTrack){
    const prev=root.querySelector('[data-review-prev]'),next=root.querySelector('[data-review-next]');
    const syncReviews=()=>{prev.disabled=reviewTrack.scrollLeft<=2;next.disabled=reviewTrack.scrollLeft>=reviewTrack.scrollWidth-reviewTrack.clientWidth-2;};
    const moveReview=direction=>{const card=reviewTrack.firstElementChild;reviewTrack.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(reviewTrack).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    prev.addEventListener('click',()=>moveReview(-1),{signal:controller.signal});
    next.addEventListener('click',()=>moveReview(1),{signal:controller.signal});
    reviewTrack.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();moveReview(e.key==='ArrowRight'?1:-1);}},{signal:controller.signal});
    reviewTrack.addEventListener('scroll',syncReviews,{passive:true,signal:controller.signal});
    const reviewResize=new ResizeObserver(syncReviews);reviewResize.observe(reviewTrack);
    controller.signal.addEventListener('abort',()=>reviewResize.disconnect(),{once:true});
    syncReviews();
  }
  update();
 };
 const mount=(scope)=>scope.querySelectorAll('[data-powerboss-section]').forEach(init);
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true}); else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
